import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-email-redirect',
  templateUrl: './email-redirect.component.html',
  styleUrls: ['./email-redirect.component.scss']
})
export class EmailRedirectComponent implements OnInit {

  constructor(private route: ActivatedRoute, private router: Router) { }

  ngOnInit(): void {
    this.route.queryParams.subscribe(params => {
      if (params['to']) {
        if (params['to'].includes('schedule-call')) {
          if (params['email_id']) {
            localStorage.setItem('user', params['email_id']);
            this.router.navigate([params['to']]);
          } else {
            this.router.navigate(['/pages/pre-steps']);
          }
        } else {
          if (params['id'] && params['email_id']) {
            const lastItem = params['to'].substring(params['to'].lastIndexOf('/') + 1)
            localStorage.setItem(lastItem, params['id']);
            localStorage.setItem('user', params['email_id']);
            this.router.navigate([params['to']]);
          } else {
            this.router.navigate(['/pages/pre-steps']);
          }
        }
      } else {
        this.router.navigate(['/pages/pre-steps']);
      }
    });
  }

}
